type UserShape = {
  name?: unknown;
  email?: unknown;
};

function normalizeName(user: UserShape): string {
  return typeof user?.name === "string" ? user.name.trim() : "";
}

function normalizeEmail(user: UserShape): string {
  return typeof user?.email === "string" ? user.email.trim() : "";
}

export function getUserInitials(user: UserShape, fallback = "CB"): string {
  const name = normalizeName(user);
  if (name.length > 0) {
    const initials = name
      .split(/\s+/)
      .filter(Boolean)
      .map((part) => part.charAt(0).toUpperCase())
      .join("")
      .slice(0, 2);
    if (initials.length > 0) {
      return initials;
    }
  }

  const email = normalizeEmail(user);
  if (email.length > 0) {
    const localPart = (email.split("@")[0] ?? "").replace(/[^a-zA-Z0-9]+/g, " ").trim();
    if (localPart.length > 0) {
      const initials = localPart
        .split(/\s+/)
        .filter(Boolean)
        .map((part) => part.charAt(0).toUpperCase())
        .join("")
        .slice(0, 2);
      if (initials.length > 0) {
        return initials;
      }
    }
    const firstChar = email.charAt(0).toUpperCase();
    if (firstChar) {
      return firstChar;
    }
  }

  return fallback;
}

export function getUserDisplayLabel(user: UserShape, fallback = "CB"): string {
  const name = normalizeName(user);
  if (name.length > 0 && !name.includes("@")) {
    return name;
  }
  return getUserInitials(user, fallback);
}
